export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "min_photos_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ajoutez au moins 3 photos de votre produit"])},
        "register_anyway": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer quand même"])},
        "current_photos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Photos actuelles"])}
      },
      "en": {
        "min_photos_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Add at least 3 photos of your product"])},
        "register_anyway": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save anyway"])},
        "current_photos": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Current photos"])}
      }
    }
  })
}
